import * as React from 'react'
import hexLight from 'assets/hex-light.svg'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'

export default function HeroTextStack({ _rawContent, _rawSideContent, image }) {
	return (
		<section className="relative">
			<img
				className="pointer-events-none absolute bottom-0 right-0 -scale-x-100 -scale-y-100"
				src={hexLight}
				alt=""
				width={767}
				height={402}
				loading="lazy"
				draggable="false"
			/>

			<div className="cntr padding relative grid items-start gap-8 md:grid-cols-[1fr,1.2fr]">
				<div className="md:sticky-below-header [&_h2]:h0 mx-auto max-w-[550px] self-start">
					<SanityBlock body={_rawContent} />
				</div>
				<div className="mx-auto max-w-[550px]">
					<SanityBlock body={_rawSideContent} />
				</div>
			</div>

			{image && (
				<figure className="mx-auto max-w-screen-lg px-4 pb-12">
					<Img image={image} />
				</figure>
			)}
		</section>
	)
}
